import React from "react";
import manheimLogo from "assets/img/Manheim.svg";

// Define the Manheim component
const Manheim = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://auth.manheim.com/as/authorization.oauth2?adaptor=manheim_customer&client_id=smzbeqp277av7kx8jmx3syk9&redirect_uri=https%3A%2F%2Fhome.manheim.com%2Fcallback&response_type=code&scope=email+profile+openid+offline_access&state=%2Flogin",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div onClick={openInNewTab}>
			<img src={manheimLogo} alt="Manheim" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default Manheim;
